const initialState = {
	findDirectoryGroups: null,
	isActivatingDirectorySync: false,
	isDirectorySyncRunning: false,
	isCollapsed: [],
	isHidden: [],
	directoryLabelsToCollapse: null,
	waitingDirectoryGroupsLevel: 0,
};

const directoryGroupReducer = (state = initialState, action ) => {
	switch (action.type) {
		case "FIND_DIRECTORY_GROUPS":
			state = {
				...state,
				findDirectoryGroups: action.payload
			};
			break;
		case "IS_ACTIVATING_DIRECTORY_SYNC":
			state = {
				...state,
				isActivatingDirectorySync: action.payload
			};
			break;
		case "IS_DIRECTORY_SYNC_RUNNING":
			state = {
				...state,
				isDirectorySyncRunning: action.payload
			};
			break;
		case "IS_COLLAPSED":
			state = {
				...state,
				isCollapsed: action.payload
			};
			break;
		case "IS_HIDDEN":
			state = {
				...state,
				isHidden: action.payload
			};
			break;
		case "DIRECTORY_LABELS_TO_COLLAPSE":
			state = {
				...state,
				directoryLabelsToCollapse: action.payload
			};
			break;
		case "WAITING_DIRECTORY_GROUPS_LEVEL":
			state = {
				...state,
				waitingDirectoryGroupsLevel: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default directoryGroupReducer;
